"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createImPalette = createImPalette;
var _styles = require("@mui/material/styles");
var _imColors = require("./im-colors");
/* eslint-disable max-lines */
/* eslint-disable sort-keys */

function createImPalette(mode) {
  function _getContrastText(backgroundColor, foregroundColor, ratio) {
    return (0, _styles.getContrastRatio)(backgroundColor, _imColors.imColors.white) > ratio ? _imColors.imColors.white : foregroundColor;
  }
  var paletteOptions = {
    mode: mode,
    common: {
      black: _imColors.imColors.black,
      white: _imColors.imColors.white
    },
    gray: {
      '25': _imColors.imColors.gray25,
      '50': _imColors.imColors.gray50,
      '100': _imColors.imColors.gray100,
      '200': _imColors.imColors.gray200,
      '300': _imColors.imColors.gray300,
      '400': _imColors.imColors.gray400,
      '500': _imColors.imColors.gray500,
      '600': _imColors.imColors.gray600,
      '700': _imColors.imColors.gray700,
      '800': _imColors.imColors.gray800,
      '900': _imColors.imColors.gray900,
      '950': _imColors.imColors.gray950,
      light: _imColors.imColors.gray300,
      main: _imColors.imColors.gray500,
      dark: _imColors.imColors.gray700,
      contrastText: _getContrastText(_imColors.imColors.gray500, _imColors.imColors.grayModern500, 1.25),
      getContrastText: function getContrastText(color) {
        return _getContrastText(color, _imColors.imColors.grayModern500, 1.25);
      }
    },
    primary: {
      '25': _imColors.imColors.primary25,
      '50': _imColors.imColors.primary50,
      '100': _imColors.imColors.primary100,
      '200': _imColors.imColors.primary200,
      '300': _imColors.imColors.primary300,
      '400': _imColors.imColors.primary400,
      '500': _imColors.imColors.primary500,
      '600': _imColors.imColors.primary600,
      '700': _imColors.imColors.primary700,
      '800': _imColors.imColors.primary800,
      '900': _imColors.imColors.primary900,
      '950': _imColors.imColors.primary950,
      light: _imColors.imColors.primary300,
      main: _imColors.imColors.primary500,
      dark: _imColors.imColors.primary700,
      contrastText: _getContrastText(_imColors.imColors.primary500, _imColors.imColors.primary700, 1.5),
      getContrastText: function getContrastText(color) {
        return _getContrastText(color, _imColors.imColors.primary700, 1.5);
      }
    },
    error: {
      '25': _imColors.imColors.error25,
      '50': _imColors.imColors.error50,
      '100': _imColors.imColors.error100,
      '200': _imColors.imColors.error200,
      '300': _imColors.imColors.error300,
      '400': _imColors.imColors.error400,
      '500': _imColors.imColors.error500,
      '600': _imColors.imColors.error600,
      '700': _imColors.imColors.error700,
      '800': _imColors.imColors.error800,
      '900': _imColors.imColors.error900,
      '950': _imColors.imColors.error950,
      light: _imColors.imColors.error300,
      main: _imColors.imColors.error500,
      dark: _imColors.imColors.error700,
      contrastText: _getContrastText(_imColors.imColors.error500, _imColors.imColors.error700, 1.5),
      getContrastText: function getContrastText(color) {
        return _getContrastText(color, _imColors.imColors.error700, 1.5);
      }
    },
    warning: {
      '25': _imColors.imColors.warning25,
      '50': _imColors.imColors.warning50,
      '100': _imColors.imColors.warning100,
      '200': _imColors.imColors.warning200,
      '300': _imColors.imColors.warning300,
      '400': _imColors.imColors.warning400,
      '500': _imColors.imColors.warning500,
      '600': _imColors.imColors.warning600,
      '700': _imColors.imColors.warning700,
      '800': _imColors.imColors.warning800,
      '900': _imColors.imColors.warning900,
      '950': _imColors.imColors.warning950,
      light: _imColors.imColors.warning300,
      main: _imColors.imColors.warning500,
      dark: _imColors.imColors.warning700,
      contrastText: _getContrastText(_imColors.imColors.warning500, _imColors.imColors.warning700, 1.5),
      getContrastText: function getContrastText(color) {
        return _getContrastText(color, _imColors.imColors.warning700, 1.5);
      }
    },
    success: {
      '25': _imColors.imColors.success25,
      '50': _imColors.imColors.success50,
      '100': _imColors.imColors.success100,
      '200': _imColors.imColors.success200,
      '300': _imColors.imColors.success300,
      '400': _imColors.imColors.success400,
      '500': _imColors.imColors.success500,
      '600': _imColors.imColors.success600,
      '700': _imColors.imColors.success700,
      '800': _imColors.imColors.success800,
      '900': _imColors.imColors.success900,
      '950': _imColors.imColors.success950,
      light: _imColors.imColors.success300,
      main: _imColors.imColors.success500,
      dark: _imColors.imColors.success700,
      contrastText: _getContrastText(_imColors.imColors.success500, _imColors.imColors.success700, 1.5),
      getContrastText: function getContrastText(color) {
        return _getContrastText(color, _imColors.imColors.success700, 1.5);
      }
    },
    grayBlue: {
      '25': _imColors.imColors.grayBlue25,
      '50': _imColors.imColors.grayBlue50,
      '100': _imColors.imColors.grayBlue100,
      '200': _imColors.imColors.grayBlue200,
      '300': _imColors.imColors.grayBlue300,
      '400': _imColors.imColors.grayBlue400,
      '500': _imColors.imColors.grayBlue500,
      '600': _imColors.imColors.grayBlue600,
      '700': _imColors.imColors.grayBlue700,
      '800': _imColors.imColors.grayBlue800,
      '900': _imColors.imColors.grayBlue900,
      '950': _imColors.imColors.grayBlue950,
      light: _imColors.imColors.grayBlue300,
      main: _imColors.imColors.grayBlue500,
      dark: _imColors.imColors.grayBlue700,
      contrastText: _getContrastText(_imColors.imColors.grayBlue500, _imColors.imColors.grayBlue500, 1.5),
      getContrastText: function getContrastText(color) {
        return _getContrastText(color, _imColors.imColors.grayBlue500, 1.5);
      }
    },
    grayCool: {
      '25': _imColors.imColors.grayCool25,
      '50': _imColors.imColors.grayCool50,
      '100': _imColors.imColors.grayCool100,
      '200': _imColors.imColors.grayCool200,
      '300': _imColors.imColors.grayCool300,
      '400': _imColors.imColors.grayCool400,
      '500': _imColors.imColors.grayCool500,
      '600': _imColors.imColors.grayCool600,
      '700': _imColors.imColors.grayCool700,
      '800': _imColors.imColors.grayCool800,
      '900': _imColors.imColors.grayCool900,
      '950': _imColors.imColors.grayCool950,
      light: _imColors.imColors.grayCool300,
      main: _imColors.imColors.grayCool500,
      dark: _imColors.imColors.grayCool700,
      contrastText: _getContrastText(_imColors.imColors.grayCool500, _imColors.imColors.grayCool500, 1.5),
      getContrastText: function getContrastText(color) {
        return _getContrastText(color, _imColors.imColors.grayCool500, 1.5);
      }
    },
    grayModern: {
      '25': _imColors.imColors.grayModern25,
      '50': _imColors.imColors.grayModern50,
      '100': _imColors.imColors.grayModern100,
      '200': _imColors.imColors.grayModern200,
      '300': _imColors.imColors.grayModern300,
      '400': _imColors.imColors.grayModern400,
      '500': _imColors.imColors.grayModern500,
      '600': _imColors.imColors.grayModern600,
      '700': _imColors.imColors.grayModern700,
      '800': _imColors.imColors.grayModern800,
      '900': _imColors.imColors.grayModern900,
      '950': _imColors.imColors.grayModern950,
      light: _imColors.imColors.grayModern300,
      main: _imColors.imColors.grayModern500,
      dark: _imColors.imColors.grayModern700,
      contrastText: _getContrastText(_imColors.imColors.grayModern500, _imColors.imColors.grayModern500, 1.25),
      getContrastText: function getContrastText(color) {
        return _getContrastText(color, _imColors.imColors.grayModern500, 1.25);
      }
    },
    grayNeutral: {
      '25': _imColors.imColors.grayNeutral25,
      '50': _imColors.imColors.grayNeutral50,
      '100': _imColors.imColors.grayNeutral100,
      '200': _imColors.imColors.grayNeutral200,
      '300': _imColors.imColors.grayNeutral300,
      '400': _imColors.imColors.grayNeutral400,
      '500': _imColors.imColors.grayNeutral500,
      '600': _imColors.imColors.grayNeutral600,
      '700': _imColors.imColors.grayNeutral700,
      '800': _imColors.imColors.grayNeutral800,
      '900': _imColors.imColors.grayNeutral900,
      '950': _imColors.imColors.grayNeutral950,
      light: _imColors.imColors.grayNeutral300,
      main: _imColors.imColors.grayNeutral500,
      dark: _imColors.imColors.grayNeutral700,
      contrastText: _getContrastText(_imColors.imColors.grayNeutral500, _imColors.imColors.grayNeutral500, 1.25),
      getContrastText: function getContrastText(color) {
        return _getContrastText(color, _imColors.imColors.grayNeutral500, 1.25);
      }
    },
    grayIron: {
      '25': _imColors.imColors.grayIron25,
      '50': _imColors.imColors.grayIron50,
      '100': _imColors.imColors.grayIron100,
      '200': _imColors.imColors.grayIron200,
      '300': _imColors.imColors.grayIron300,
      '400': _imColors.imColors.grayIron400,
      '500': _imColors.imColors.grayIron500,
      '600': _imColors.imColors.grayIron600,
      '700': _imColors.imColors.grayIron700,
      '800': _imColors.imColors.grayIron800,
      '900': _imColors.imColors.grayIron900,
      '950': _imColors.imColors.grayIron950,
      light: _imColors.imColors.grayIron300,
      main: _imColors.imColors.grayIron500,
      dark: _imColors.imColors.grayIron700,
      contrastText: _getContrastText(_imColors.imColors.grayIron500, _imColors.imColors.grayIron500, 1.5),
      getContrastText: function getContrastText(color) {
        return _getContrastText(color, _imColors.imColors.grayIron500, 1.5);
      }
    },
    grayTrue: {
      '25': _imColors.imColors.grayTrue25,
      '50': _imColors.imColors.grayTrue50,
      '100': _imColors.imColors.grayTrue100,
      '200': _imColors.imColors.grayTrue200,
      '300': _imColors.imColors.grayTrue300,
      '400': _imColors.imColors.grayTrue400,
      '500': _imColors.imColors.grayTrue500,
      '600': _imColors.imColors.grayTrue600,
      '700': _imColors.imColors.grayTrue700,
      '800': _imColors.imColors.grayTrue800,
      '900': _imColors.imColors.grayTrue900,
      '950': _imColors.imColors.grayTrue950,
      light: _imColors.imColors.grayTrue300,
      main: _imColors.imColors.grayTrue500,
      dark: _imColors.imColors.grayTrue700,
      contrastText: _getContrastText(_imColors.imColors.grayTrue500, _imColors.imColors.grayTrue500, 1.35),
      getContrastText: function getContrastText(color) {
        return _getContrastText(color, _imColors.imColors.grayTrue500, 1.35);
      }
    },
    grayWarm: {
      '25': _imColors.imColors.grayWarm25,
      '50': _imColors.imColors.grayWarm50,
      '100': _imColors.imColors.grayWarm100,
      '200': _imColors.imColors.grayWarm200,
      '300': _imColors.imColors.grayWarm300,
      '400': _imColors.imColors.grayWarm400,
      '500': _imColors.imColors.grayWarm500,
      '600': _imColors.imColors.grayWarm600,
      '700': _imColors.imColors.grayWarm700,
      '800': _imColors.imColors.grayWarm800,
      '900': _imColors.imColors.grayWarm900,
      '950': _imColors.imColors.grayWarm950,
      light: _imColors.imColors.grayWarm300,
      main: _imColors.imColors.grayWarm500,
      dark: _imColors.imColors.grayWarm700,
      contrastText: _getContrastText(_imColors.imColors.grayWarm500, _imColors.imColors.grayWarm500, 1.35),
      getContrastText: function getContrastText(color) {
        return _getContrastText(color, _imColors.imColors.grayWarm500, 1.35);
      }
    },
    moss: {
      '25': _imColors.imColors.moss25,
      '50': _imColors.imColors.moss50,
      '100': _imColors.imColors.moss100,
      '200': _imColors.imColors.moss200,
      '300': _imColors.imColors.moss300,
      '400': _imColors.imColors.moss400,
      '500': _imColors.imColors.moss500,
      '600': _imColors.imColors.moss600,
      '700': _imColors.imColors.moss700,
      '800': _imColors.imColors.moss800,
      '900': _imColors.imColors.moss900,
      '950': _imColors.imColors.moss950,
      light: _imColors.imColors.moss300,
      main: _imColors.imColors.moss500,
      dark: _imColors.imColors.moss700,
      contrastText: _getContrastText(_imColors.imColors.moss500, _imColors.imColors.moss700, 1.5),
      getContrastText: function getContrastText(color) {
        return _getContrastText(color, _imColors.imColors.moss700, 1.5);
      }
    },
    greenLight: {
      '25': _imColors.imColors.greenLight25,
      '50': _imColors.imColors.greenLight50,
      '100': _imColors.imColors.greenLight100,
      '200': _imColors.imColors.greenLight200,
      '300': _imColors.imColors.greenLight300,
      '400': _imColors.imColors.greenLight400,
      '500': _imColors.imColors.greenLight500,
      '600': _imColors.imColors.greenLight600,
      '700': _imColors.imColors.greenLight700,
      '800': _imColors.imColors.greenLight800,
      '900': _imColors.imColors.greenLight900,
      '950': _imColors.imColors.greenLight950,
      light: _imColors.imColors.greenLight300,
      main: _imColors.imColors.greenLight500,
      dark: _imColors.imColors.greenLight700,
      contrastText: _getContrastText(_imColors.imColors.greenLight700, _imColors.imColors.greenLight700, 1.25),
      getContrastText: function getContrastText(color) {
        return _getContrastText(color, _imColors.imColors.greenLight700, 1.25);
      }
    },
    green: {
      '25': _imColors.imColors.green25,
      '50': _imColors.imColors.green50,
      '100': _imColors.imColors.green100,
      '200': _imColors.imColors.green200,
      '300': _imColors.imColors.green300,
      '400': _imColors.imColors.green400,
      '500': _imColors.imColors.green500,
      '600': _imColors.imColors.green600,
      '700': _imColors.imColors.green700,
      '800': _imColors.imColors.green800,
      '900': _imColors.imColors.green900,
      '950': _imColors.imColors.green950,
      light: _imColors.imColors.green300,
      main: _imColors.imColors.green500,
      dark: _imColors.imColors.green700,
      contrastText: _getContrastText(_imColors.imColors.green500, _imColors.imColors.green700, 1.5),
      getContrastText: function getContrastText(color) {
        return _getContrastText(color, _imColors.imColors.green700, 1.5);
      }
    },
    teal: {
      '25': _imColors.imColors.teal25,
      '50': _imColors.imColors.teal50,
      '100': _imColors.imColors.teal100,
      '200': _imColors.imColors.teal200,
      '300': _imColors.imColors.teal300,
      '400': _imColors.imColors.teal400,
      '500': _imColors.imColors.teal500,
      '600': _imColors.imColors.teal600,
      '700': _imColors.imColors.teal700,
      '800': _imColors.imColors.teal800,
      '900': _imColors.imColors.teal900,
      '950': _imColors.imColors.teal950,
      light: _imColors.imColors.teal300,
      main: _imColors.imColors.teal500,
      dark: _imColors.imColors.teal700,
      contrastText: _getContrastText(_imColors.imColors.teal500, _imColors.imColors.teal700, 1.35),
      getContrastText: function getContrastText(color) {
        return _getContrastText(color, _imColors.imColors.teal700, 1.35);
      }
    },
    cyan: {
      '25': _imColors.imColors.cyan25,
      '50': _imColors.imColors.cyan50,
      '100': _imColors.imColors.cyan100,
      '200': _imColors.imColors.cyan200,
      '300': _imColors.imColors.cyan300,
      '400': _imColors.imColors.cyan400,
      '500': _imColors.imColors.cyan500,
      '600': _imColors.imColors.cyan600,
      '700': _imColors.imColors.cyan700,
      '800': _imColors.imColors.cyan800,
      '900': _imColors.imColors.cyan900,
      '950': _imColors.imColors.cyan950,
      light: _imColors.imColors.cyan300,
      main: _imColors.imColors.cyan500,
      dark: _imColors.imColors.cyan700,
      contrastText: _getContrastText(_imColors.imColors.cyan500, _imColors.imColors.cyan700, 1.5),
      getContrastText: function getContrastText(color) {
        return _getContrastText(color, _imColors.imColors.cyan700, 1.5);
      }
    },
    blueLight: {
      '25': _imColors.imColors.blueLight25,
      '50': _imColors.imColors.blueLight50,
      '100': _imColors.imColors.blueLight100,
      '200': _imColors.imColors.blueLight200,
      '300': _imColors.imColors.blueLight300,
      '400': _imColors.imColors.blueLight400,
      '500': _imColors.imColors.blueLight500,
      '600': _imColors.imColors.blueLight600,
      '700': _imColors.imColors.blueLight700,
      '800': _imColors.imColors.blueLight800,
      '900': _imColors.imColors.blueLight900,
      '950': _imColors.imColors.blueLight950,
      light: _imColors.imColors.blueLight300,
      main: _imColors.imColors.blueLight500,
      dark: _imColors.imColors.blueLight700,
      contrastText: _getContrastText(_imColors.imColors.blueLight500, _imColors.imColors.blueLight700, 1.5),
      getContrastText: function getContrastText(color) {
        return _getContrastText(color, _imColors.imColors.blueLight700, 1.5);
      }
    },
    blue: {
      '25': _imColors.imColors.blue25,
      '50': _imColors.imColors.blue50,
      '100': _imColors.imColors.blue100,
      '200': _imColors.imColors.blue200,
      '300': _imColors.imColors.blue300,
      '400': _imColors.imColors.blue400,
      '500': _imColors.imColors.blue500,
      '600': _imColors.imColors.blue600,
      '700': _imColors.imColors.blue700,
      '800': _imColors.imColors.blue800,
      '900': _imColors.imColors.blue900,
      '950': _imColors.imColors.blue950,
      light: _imColors.imColors.blue300,
      main: _imColors.imColors.blue500,
      dark: _imColors.imColors.blue700,
      contrastText: _getContrastText(_imColors.imColors.blue500, _imColors.imColors.blue700, 1.5),
      getContrastText: function getContrastText(color) {
        return _getContrastText(color, _imColors.imColors.blue700, 1.5);
      }
    },
    blueDark: {
      '25': _imColors.imColors.blueDark25,
      '50': _imColors.imColors.blueDark50,
      '100': _imColors.imColors.blueDark100,
      '200': _imColors.imColors.blueDark200,
      '300': _imColors.imColors.blueDark300,
      '400': _imColors.imColors.blueDark400,
      '500': _imColors.imColors.blueDark500,
      '600': _imColors.imColors.blueDark600,
      '700': _imColors.imColors.blueDark700,
      '800': _imColors.imColors.blueDark800,
      '900': _imColors.imColors.blueDark900,
      '950': _imColors.imColors.blueDark950,
      light: _imColors.imColors.blueDark300,
      main: _imColors.imColors.blueDark500,
      dark: _imColors.imColors.blueDark700,
      contrastText: _getContrastText(_imColors.imColors.blueDark500, _imColors.imColors.blueDark700, 1.75),
      getContrastText: function getContrastText(color) {
        return _getContrastText(color, _imColors.imColors.blueDark700, 1.75);
      }
    },
    indigo: {
      '25': _imColors.imColors.indigo25,
      '50': _imColors.imColors.indigo50,
      '100': _imColors.imColors.indigo100,
      '200': _imColors.imColors.indigo200,
      '300': _imColors.imColors.indigo300,
      '400': _imColors.imColors.indigo400,
      '500': _imColors.imColors.indigo500,
      '600': _imColors.imColors.indigo600,
      '700': _imColors.imColors.indigo700,
      '800': _imColors.imColors.indigo800,
      '900': _imColors.imColors.indigo900,
      '950': _imColors.imColors.indigo950,
      light: _imColors.imColors.indigo300,
      main: _imColors.imColors.indigo500,
      dark: _imColors.imColors.indigo700,
      contrastText: _getContrastText(_imColors.imColors.indigo500, _imColors.imColors.indigo700, 1.5),
      getContrastText: function getContrastText(color) {
        return _getContrastText(color, _imColors.imColors.indigo700, 1.5);
      }
    },
    violet: {
      '25': _imColors.imColors.violet25,
      '50': _imColors.imColors.violet50,
      '100': _imColors.imColors.violet100,
      '200': _imColors.imColors.violet200,
      '300': _imColors.imColors.violet300,
      '400': _imColors.imColors.violet400,
      '500': _imColors.imColors.violet500,
      '600': _imColors.imColors.violet600,
      '700': _imColors.imColors.violet700,
      '800': _imColors.imColors.violet800,
      '900': _imColors.imColors.violet900,
      '950': _imColors.imColors.violet950,
      light: _imColors.imColors.violet300,
      main: _imColors.imColors.violet500,
      dark: _imColors.imColors.violet700,
      contrastText: _getContrastText(_imColors.imColors.violet500, _imColors.imColors.violet700, 1.5),
      getContrastText: function getContrastText(color) {
        return _getContrastText(color, _imColors.imColors.violet700, 1.5);
      }
    },
    purple: {
      '25': _imColors.imColors.purple25,
      '50': _imColors.imColors.purple50,
      '100': _imColors.imColors.purple100,
      '200': _imColors.imColors.purple200,
      '300': _imColors.imColors.purple300,
      '400': _imColors.imColors.purple400,
      '500': _imColors.imColors.purple500,
      '600': _imColors.imColors.purple600,
      '700': _imColors.imColors.purple700,
      '800': _imColors.imColors.purple800,
      '900': _imColors.imColors.purple900,
      '950': _imColors.imColors.purple950,
      light: _imColors.imColors.purple300,
      main: _imColors.imColors.purple500,
      dark: _imColors.imColors.purple700,
      contrastText: _getContrastText(_imColors.imColors.purple500, _imColors.imColors.purple700, 1.5),
      getContrastText: function getContrastText(color) {
        return _getContrastText(color, _imColors.imColors.purple700, 1.5);
      }
    },
    fuchsia: {
      '25': _imColors.imColors.fuchsia25,
      '50': _imColors.imColors.fuchsia50,
      '100': _imColors.imColors.fuchsia100,
      '200': _imColors.imColors.fuchsia200,
      '300': _imColors.imColors.fuchsia300,
      '400': _imColors.imColors.fuchsia400,
      '500': _imColors.imColors.fuchsia500,
      '600': _imColors.imColors.fuchsia600,
      '700': _imColors.imColors.fuchsia700,
      '800': _imColors.imColors.fuchsia800,
      '900': _imColors.imColors.fuchsia900,
      '950': _imColors.imColors.fuchsia950,
      light: _imColors.imColors.fuchsia300,
      main: _imColors.imColors.fuchsia500,
      dark: _imColors.imColors.fuchsia700,
      contrastText: _getContrastText(_imColors.imColors.fuchsia500, _imColors.imColors.fuchsia700, 1.5),
      getContrastText: function getContrastText(color) {
        return _getContrastText(color, _imColors.imColors.fuchsia700, 1.5);
      }
    },
    pink: {
      '25': _imColors.imColors.pink25,
      '50': _imColors.imColors.pink50,
      '100': _imColors.imColors.pink100,
      '200': _imColors.imColors.pink200,
      '300': _imColors.imColors.pink300,
      '400': _imColors.imColors.pink400,
      '500': _imColors.imColors.pink500,
      '600': _imColors.imColors.pink600,
      '700': _imColors.imColors.pink700,
      '800': _imColors.imColors.pink800,
      '900': _imColors.imColors.pink900,
      '950': _imColors.imColors.pink950,
      light: _imColors.imColors.pink300,
      main: _imColors.imColors.pink500,
      dark: _imColors.imColors.pink700,
      contrastText: _getContrastText(_imColors.imColors.pink500, _imColors.imColors.pink700, 1.5),
      getContrastText: function getContrastText(color) {
        return _getContrastText(color, _imColors.imColors.pink700, 1.5);
      }
    },
    rose: {
      '25': _imColors.imColors.rose25,
      '50': _imColors.imColors.rose50,
      '100': _imColors.imColors.rose100,
      '200': _imColors.imColors.rose200,
      '300': _imColors.imColors.rose300,
      '400': _imColors.imColors.rose400,
      '500': _imColors.imColors.rose500,
      '600': _imColors.imColors.rose600,
      '700': _imColors.imColors.rose700,
      '800': _imColors.imColors.rose800,
      '900': _imColors.imColors.rose900,
      '950': _imColors.imColors.rose950,
      light: _imColors.imColors.rose300,
      main: _imColors.imColors.rose500,
      dark: _imColors.imColors.rose700,
      getContrastText: function getContrastText(color) {
        return (0, _styles.getContrastRatio)(color, _imColors.imColors.white) > 1.5 ? _imColors.imColors.white : _imColors.imColors.pink700;
      }
    },
    orangeDark: {
      '25': _imColors.imColors.orangeDark25,
      '50': _imColors.imColors.orangeDark50,
      '100': _imColors.imColors.orangeDark100,
      '200': _imColors.imColors.orangeDark200,
      '300': _imColors.imColors.orangeDark300,
      '400': _imColors.imColors.orangeDark400,
      '500': _imColors.imColors.orangeDark500,
      '600': _imColors.imColors.orangeDark600,
      '700': _imColors.imColors.orangeDark700,
      '800': _imColors.imColors.orangeDark800,
      '900': _imColors.imColors.orangeDark900,
      '950': _imColors.imColors.orangeDark950,
      light: _imColors.imColors.orangeDark300,
      main: _imColors.imColors.orangeDark500,
      dark: _imColors.imColors.orangeDark700,
      contrastText: _getContrastText(_imColors.imColors.orangeDark500, _imColors.imColors.orange700, 1.5),
      getContrastText: function getContrastText(color) {
        return _getContrastText(color, _imColors.imColors.orange700, 1.5);
      }
    },
    orange: {
      '25': _imColors.imColors.orange25,
      '50': _imColors.imColors.orange50,
      '100': _imColors.imColors.orange100,
      '200': _imColors.imColors.orange200,
      '300': _imColors.imColors.orange300,
      '400': _imColors.imColors.orange400,
      '500': _imColors.imColors.orange500,
      '600': _imColors.imColors.orange600,
      '700': _imColors.imColors.orange700,
      '800': _imColors.imColors.orange800,
      '900': _imColors.imColors.orange900,
      '950': _imColors.imColors.orange950,
      light: _imColors.imColors.orange300,
      main: _imColors.imColors.orange500,
      dark: _imColors.imColors.orange700,
      contrastText: _getContrastText(_imColors.imColors.orange500, _imColors.imColors.orange700, 1.5),
      getContrastText: function getContrastText(color) {
        return _getContrastText(color, _imColors.imColors.orange700, 1.5);
      }
    },
    yellow: {
      '25': _imColors.imColors.yellow25,
      '50': _imColors.imColors.yellow50,
      '100': _imColors.imColors.yellow100,
      '200': _imColors.imColors.yellow200,
      '300': _imColors.imColors.yellow300,
      '400': _imColors.imColors.yellow400,
      '500': _imColors.imColors.yellow500,
      '600': _imColors.imColors.yellow600,
      '700': _imColors.imColors.yellow700,
      '800': _imColors.imColors.yellow800,
      '900': _imColors.imColors.yellow900,
      '950': _imColors.imColors.yellow950,
      light: _imColors.imColors.yellow300,
      main: _imColors.imColors.yellow500,
      dark: _imColors.imColors.yellow700,
      contrastText: _getContrastText(_imColors.imColors.yellow500, _imColors.imColors.yellow700, 1.25),
      getContrastText: function getContrastText(color) {
        return _getContrastText(color, _imColors.imColors.yellow700, 1.25);
      }
    }
  };
  return (0, _styles.createTheme)({
    palette: paletteOptions
  }).palette;
}